
import { PixelScriptMetadata } from "../../UpdatePixelScript";
import { ScriptAttributes } from "./script-types";

// Configuration constants
const EDGE_FUNCTION_URL = "https://embqetqnbgbpzkekvuhi.supabase.co/functions/v1/serve-tracking-script";
const SUPABASE_URL = "https://embqetqnbgbpzkekvuhi.supabase.co";
const API_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVtYnFldHFuYmdicHprZWt2dWhpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg5NTg1NzcsImV4cCI6MjA1NDUzNDU3N30.om_wXs8emRG4ooRN1NCtAxbs-CcLZ9gXOeQTR1gGxkI";

export function buildScriptTag(attrs: ScriptAttributes): string {
  const version = attrs.version || attrs.scriptMetadata?.version || "v1.1";
  
  // Ensure pixelId is always present and valid
  if (!attrs.pixelId) {
    console.error('Pixel ID is required for script generation');
    throw new Error('Pixel ID must be provided');
  }

  // Build URL parameters more robustly
  const urlParams = new URLSearchParams();
  
  // Always include the pixel ID in URL parameters - this is critical
  urlParams.append('pid', attrs.pixelId);
  
  // Always include the API key in URL parameters for robustness
  urlParams.append('key', API_KEY);
  
  // Conditionally add debug and test parameters
  if (attrs.debug) {
    urlParams.append('debug', 'true');
  }
  
  if (attrs.isTest) {
    urlParams.append('test', 'true');
  }
  
  if (attrs.disabled) {
    urlParams.append('disabled', 'true');
  }
  
  // Add a timestamp parameter to bust the cache
  urlParams.append('v', Date.now().toString());
  
  const urlParamsString = urlParams.toString();
  const scriptUrl = `${EDGE_FUNCTION_URL}${urlParamsString ? '?' + urlParamsString : ''}`;
  
  // Add ALL necessary attributes, including data-pid and data-url
  return `<script
  id="pixel-js"
  async 
  src="${scriptUrl}"
  crossorigin="anonymous"
  type="text/javascript"
  data-pid="${attrs.pixelId}"
  data-url="${SUPABASE_URL}"
  data-key="${API_KEY}"
  ${attrs.disabled ? 'data-tracking="disabled"' : ''}
></script>`;
}
